import { Box, Button, Center, Flex, Text } from "@chakra-ui/react";
import styled from "@emotion/styled";
import { HEADER_GROUP, useNewNavigate } from "@shared/client";
import { FONT, MEDIA } from "@styles/common";
import theme from "@styles/theme";
import { useLocation } from "react-router-dom";
import { useScrollGnb } from "./hooks";

export const Header = ({ pensionName }: { pensionName?: string }) => {
    const { onNavigate } = useNewNavigate();
    const { pathname } = useLocation();
    const pathId = pathname.split("/")[1];

    const { isMobile, isTablet } = MEDIA();
    const { isScrollDown } = useScrollGnb();

    const handleNavigateToAdmin = () => {
        window.open("http://marginmax.me/login");
    };

    const isPaymentOrBookingConfirmPage = pathname.includes("/payment") || pathname.includes("/bookingConfirm");

    return (
        <Center
            flexDir="column"
            position="fixed"
            w="100%"
            zIndex="10"
            top={isScrollDown ? "-40px" : "0"}
            transition="0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275)"
        >
            <Center
                position="relative"
                w="100%"
                h="40px"
                p="16px"
                boxSizing="border-box"
                columnGap="16px"
                justifyContent="space-between"
                bgColor={theme.COLOR.black}
            >
                <CustomText>{pensionName}</CustomText>
                <Button
                    size="medium"
                    p="4px 12px"
                    fontFamily="Pretendard Variable"
                    fontWeight="500"
                    fontSize="14px"
                    onClick={handleNavigateToAdmin}
                >
                    <span className="material-icons" style={{ fontSize: "14px" }}>
                        app_registration
                    </span>
                    <Text ml="4px">관리자 페이지</Text>
                </Button>
            </Center>
            <Center
                w="100%"
                h="72px"
                borderBottom="1px solid"
                bgColor={theme.COLOR.white}
                borderBottomColor={theme.COLOR.gray[300]}
                padding="16px"
            >
                <Flex
                    position="relative"
                    maxWidth="1600px"
                    w="100%"
                    flexDir={isTablet ? "column" : "row"}
                    justifyContent="flex-start"
                    alignItems="center"
                >
                    <Flex
                        w="100%"
                        gap="4px"
                        boxSizing="border-box"
                        justifyContent={isPaymentOrBookingConfirmPage ? "flex-start" : "center"}
                    >
                        {isPaymentOrBookingConfirmPage ? (
                            <Flex
                                alignItems="center"
                                columnGap="4px"
                                cursor={"pointer"}
                                onClick={() => onNavigate({ path: "reserve" })}
                            >
                                <Text as="span" className="material-icons" fontSize="16px">
                                    arrow_back_ios
                                </Text>
                                <Text
                                    fontFamily={"Pretendard Variable"}
                                    fontWeight={"700"}
                                    lineHeight={"1.5"}
                                    fontSize={isMobile ? "16px" : "20px"}
                                >
                                    뒤로가기
                                </Text>
                            </Flex>
                        ) : (
                            <>
                                {HEADER_GROUP.map((menu) => {
                                    return (
                                        <CustomMenu
                                            display={isTablet && menu.title === "예약현황" ? "none" : "block"}
                                            key={menu.id}
                                            fontSize={isMobile ? "12px" : "16px"}
                                            onClick={() => onNavigate({ path: `${menu.path}` })}
                                            color={
                                                menu.id.includes(pathId) ? theme.COLOR.pink[200] : theme.COLOR.gray[500]
                                            }
                                            border={
                                                menu.id.includes(pathId) ? `1px solid ${theme.COLOR.pink[200]}` : "none"
                                            }
                                        >
                                            {menu.title}
                                        </CustomMenu>
                                    );
                                })}
                            </>
                        )}
                    </Flex>
                </Flex>
            </Center>
        </Center>
    );
};

const CustomMenu = styled(Box)`
    padding: 8px 48px;
    border-radius: 57px;
    box-sizing: border-box;
    ${FONT("pretendard", 16, 700, 1.5)};
    cursor: pointer;

    @media (max-width: ${({ theme }) => theme.MEDIA.mobile}) {
        font-size: 14px !important;
        padding: 8px 46px;
    }

    &:hover {
        color: ${({ theme }) => theme.COLOR.pink[200]};
    }
`;

const CustomText = styled(Text)`
    ${FONT("pretendard", 20, 500)}
    color: ${({ theme }) => theme.COLOR.white};
`;
